import { CatalogEnvService } from '@aipb/gulliver/catalog/env';
import { CatalogRouting } from '@aipb/gulliver/catalog/routing';
import { Routes } from '@angular/router';
import { TopicSingleComponent } from './pages/topic-single/topic-single.component';
import { TOPICS } from './topic.tokens';

export const TopicRoutes: Routes = [
  {
    path: CatalogRouting.topicSinglePath,
    providers: [
      {
        provide: TOPICS,
        useFactory: (catalogEnv: CatalogEnvService) => catalogEnv.env.topics,
        deps: [CatalogEnvService]
      }
    ],
    component: TopicSingleComponent
  }
];
